// File: client/src/components/rules/expressionEditor/HtmlRenderer.js
import React, { useRef, useEffect } from 'react';

/**
 * HtmlRenderer component renders HTML content in a sandboxed iframe
 * This is safer than using dangerouslySetInnerHTML
 */
const HtmlRenderer = ({
                          html,
                          width = '100%',
                          height = 200,
                          style = {},
                          title = 'HTML Preview'
                      }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        if (iframeRef.current) {
            const iframe = iframeRef.current;
            const document = iframe.contentDocument || iframe.contentWindow.document;

            // Reset the document
            document.open();

            // Add default styles and content security policy
            const content = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <meta http-equiv="Content-Security-Policy" content="default-src 'self'; style-src 'unsafe-inline';">
                    <title>${title}</title>
                    <style>
                        body {
                            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                            margin: 0;
                            padding: 8px;
                            font-size: 14px;
                            line-height: 1.5;
                        }
                    </style>
                </head>
                <body>
                    ${html || ''}
                </body>
                </html>
            `;

            document.write(content);
            document.close();
        }
    }, [html, title]);

    return (
        <iframe
            ref={iframeRef}
            title={title}
            style={{
                border: '1px solid #d9d9d9',
                borderRadius: 2,
                width,
                height,
                ...style
            }}
            sandbox="allow-same-origin"
        />
    );
};

export default HtmlRenderer;
